import BasicRouterView from "../../components/BasicRouterView.vue";

const segurancaRoutes = {
  path: "seg",
  redirect: { name: "seguranca-lista" },
  meta: {
    label: "Segurança",
    icon: "security",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "seguranca/consulta-ficha",
      name: "seguranca-consulta-ficha",
      meta: {
        label: "Consulta Ficha EPIs",
        icon: "engineering",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "seguranca" */ "./views/ConsultaFichaEpis.vue"
        ),
    },
    {
      path: "seguranca/consulta-ficha-legado",
      name: "seguranca-consulta-ficha-legado",
      meta: {
        label: "Consulta Ficha EPIs Legado",
        icon: "engineering",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "seguranca" */ "./views/ConsultaFichaEpisLegado.vue"
        ),
    },
    {
      path: "seguranca/consulta-ficha-legado-detalhe/:id",
      name: "seguranca-consulta-ficha-legado-detalhe",
      meta: {
        label: "Detalhe Ficha EPIs Legado",
        icon: "engineering",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "seguranca" */ "./views/DetalheFichaEpisLegado.vue"
        ),
    },
    {
      path: "seguranca/impressao-ficha-epi/:unidadeId/:solicitanteId/:solicitanteSap/:dataInicial/:dataFinal/:solicitanteName",
      name: "seguranca-impressao-fichadeepi",
      meta: {
        label: "Consulta Ficha EPIs",
        icon: "engineering",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "seguranca" */ "./views/FichaEpiImpressao.vue"
        ),
    },

    {
      path: "seguranca/configurar-ficha-epi",
      name: "configurarfichaepi",
      meta: {
        label: "Customização de Ficha de EPI",
        icon: "badge",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "bko" */ "../seguranca/views/ConfigurarFichaEpi.vue"
        ),
    },
    {
      path: "seguranca/consultar-export-ficha-epi",
      name: "seguranca-consultar-export-ficha-epi",
      meta: {
        label: "Consulta export ficha EPI",
        icon: "badge",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "bko" */ "../seguranca/views/ConsultaExportFichaEpi.vue"
        ),
    },
  ],
};

export default segurancaRoutes;
